import React, { useRef } from "react";
import "./Join.css";
import emailjs from "@emailjs/browser";
const Join = () => {
  const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
        .sendForm("service_1qog9aj", "template_gmzgtxf", form.current, {
            publicKey: "43z3xRapReDvXA8nW",
        })
        .then(
            () => {
            console.log("SUCCESS!");
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );
    };
  return (
    <div className="Join" id="join-us">
      <div className="left-j">
        <hr />
        <div>
          <span className="stroke-text">Pronto para </span>
          <span>levar seu corpo</span>
        </div>
        <div>
          <span>ao próximo nível</span>
          <span className="stroke-text">Conosco?</span>
        </div>
      </div>
      <div className="right-j">
        <form ref={form} action="" className="email-container" onSubmit={sendEmail}>
          <input
            type="email"
            name="seu_email"
            placeholder="Digite seu endereço de e-mail"
          />
          <button className="btn btn-j">Acesse agora</button>
        </form>
      </div>
    </div>
  );
};
export default Join;
